// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//const apiPath = window['AIS']['api'];
//const assetPath = window['CCR']['assetPath'];
//const apiPath = 'https://localhost:7210/api/CCR';
const uiUrl = 'https://qa-ccr.centerpointenergy.com'
const apiPath = 'https://qa-ccr-api.centerpointenergy.com/';
export const environment = {
  appInsights: {
    instrumentationKey: '3bec79e5-90f7-48d3-ac52-933b26b4b6b9'
  },
  production: false,
  msalConfig: {
    auth: {
      clientId: 'a0eb2a47-88ad-43e7-8959-a261b366777f',
      authority: 'https://login.microsoftonline.com/88cc5fd7-fd78-44b6-ad75-b6915088974f',
      redirectUri: uiUrl,
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false, // set to true for IE 11
    }
  },
  profilePhtotoUrl: "https://cnptoday.com:443/Badge/Badges/",
  appTitle: "Customer Call Records",
  appName: "CCR",
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
    dirURI: 'https://graph.microsoft.com/v1.0/users/profileId/memberof?$count=true&$filter=startswith(displayName,\'G-CCR\')',
    userIdFilter: '?$select=employeeId',
    apiPath: apiPath
  },
  apiConfig1: {
    scopes: ['api://cbfe4bf0-3850-4c0e-bf66-83bc25c0187c/CCR_Read', 'user.read'],
  },
  api: apiPath,
  assets: uiUrl + '/assets',
  appSettings: {
    snakbarLife: 3000,
    sessionTimeoutMinutes: 30
  },
  appMessages: {
    loadingMesage: 'Loading, please wait..',
    savinggMesage: 'Saving, please wait..',
    missingData: 'Please select required information',
    errorSaving: 'Error saving data, please try again.',
    saveSuccess: 'Data saved successfully ',
    dataLoaded: 'Data loaded successfully',
    noChangesFound: 'No Changes to be saved',
    noData: "No Data Found",
    noChanges: 'No Changes',
    errorFetchingData: 'Error fetching data.',
    ServerError: 'An error occurred while retrieving the data, please try again later',
    SaveValidation: 'There were errors with your request. Please make the following corrections and try again.',
    RecordExist: 'Record is already exist for the ',
    SAPWORequired: 'SAP WO is requied when Data In SAP is marked Yes ',
    ServiceTechRequired: 'Service Tech First and Last name is required when Dispatched or Tecod selected.',
    DeltaError: 'Error retrieving permissions, try again...'
  }
}
/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
